import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimateSharedLayout, AnimatePresence } from "framer-motion";
import ParticlesBg from "particles-bg";

function Item({ title, description, school, date }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <motion.li layout onClick={toggleOpen} className="overflow-hidden cursor-pointer p-5 mb-5 rounded-lg bg-slate-300 w-4/6" initial={{ borderRadius: 10 }}>
      <motion.div className="flex w-full justify-between" layout>
        <motion.div className="w-0 h-10 md:w-10 md:h-10 bg-gray-700 rounded-2xl" layout />
        <motion.h2 className="text-gray-800 text-3xl font-semibold">{title}</motion.h2>
      </motion.div>
      <AnimatePresence>{isOpen && <Content title={title} description={description} school={school} date={date} />}</AnimatePresence>
    </motion.li>
  );
}

function Content({ description, school, date }) {
  return (
    <motion.div className="mt-6" layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <motion.div className="flex w-full justify-between" layout>
        <motion.h2 className="text-gray-800 text-2xl font-semibold" layout>
          {school}
        </motion.h2>
        <motion.p>{date}</motion.p>
      </motion.div>
      <motion.p className="mt-2 text-gray-600 text-lg">{description} </motion.p>
    </motion.div>
  );
}

const Education = () => {
  const { t } = useTranslation();

  let config = {
    num: [4, 7],
    rps: 0.1,
    radius: [5, 40],
    life: [1.5, 3],
    v: [2, 3],
    tha: [-40, 40],
    alpha: [0.6, 0],
    scale: [0.1, 0.4],
    position: "all",
    color: ["random", "#ff0000"],
    cross: "dead",
    //emitter: "follow",
    random: 15,
  };

  if (Math.random() > 0.85) {
    config = Object.assign(config, {
      onParticleUpdate: (ctx, particle) => {
        ctx.beginPath();
        ctx.rect(particle.p.x, particle.p.y, particle.radius * 2, particle.radius * 2);
        ctx.fillStyle = particle.color;
        ctx.fill();
        ctx.closePath();
      },
    });
  }

  return (
    <>
      <ParticlesBg type="custom" config={config} bg={{ position: "fixed" }} />
      <AnimateSharedLayout>
        <motion.ul layout className="content-list" initial={{ borderRadius: 25 }}>
          {t("educationData", { returnObjects: true }).map((item, key) => (
            <Item key={key} title={item.title} description={item.description} school={item.school} date={item.date} />
          ))}
        </motion.ul>
      </AnimateSharedLayout>
    </>
  );
};

export default Education;
